import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function labelUniqueValidator(existingLabels: string[] | undefined): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const enteredLabel = control.value?.trim();
    if (!enteredLabel || !Array.isArray(existingLabels)) return null;

    const labelExists = existingLabels.includes(enteredLabel);
    return labelExists ? { labelAlreadyExists: true } : null;
  };
}
